<template>
  <div class="rib-detail">
    <div class="jc-page-header">
      <el-page-header show-back-icon :title="$t('rib.rib')" @back="goBack" class="relative">
				<template slot="content">
					<span class="long-name" :title="detail.name">
						{{detail.name}}
					</span>	
          <div class="jc-list__header--right jc-box-action">
            <a target="_blank" :href="Config.ROUTETABLE_HELP_URL">{{ $t('rib.helpDoc') }}</a>
          </div>					
				</template>
			</el-page-header>
    </div>
    <div class="jc-page-content">
      <el-tabs type="border-card" v-model="tabName">
        <el-tab-pane name="source" :label="$t('rib.sourceInfo')">
          <div class="jc-section">
            <div class="jc-section-header">
              <h3 class="jc-section-title">{{ $t('rib.baseInfo') }}</h3>
            </div>
            <div class="jc-section-content">
              <el-form class="base-info-form">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item :label="$t('rib.id') | withColon">
                      <p>
                        <span>{{ detail.routeTableId }}</span>
                        <copy-value :copyVal="`${detail.routeTableId}`"></copy-value>
                        <!-- <el-tooltip :content="$t('rib.copySuccess')"
                                    effect="dark"
                                    placement="bottom"
                                    :disabled="!copyHover"
                                    class="tooltip-item">
                          <span @mouseout="copyHover = false">
                          <el-button type="text"
                                     icon="el-icon-document-copy"
                                     v-clipboard:copy="detail.routeTableId"
                                     v-clipboard:success="onCopy"
                                     v-clipboard:error="onError"></el-button>
                        </span>
                        </el-tooltip> -->
                      </p>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rib.name') | withColon">
                      <span>
                        {{(detail.name) | maybeEmpty }}
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rib.createTime') | withColon">
                      <span>
                        {{ transformTime(detail.createTime) | maybeEmpty }}
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rib.region') | withColon">
                      <span>
                        {{(detail.regionName) | maybeEmpty }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="jc-section">
            <div class="jc-section-header">
              <h3 class="jc-section-title">{{ $t('rib.configInfo') }}</h3>
            </div>
            <div class="jc-section-content">
              <el-form>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item :label="$t('rib.privateNetwork') | withColon">
                      <a href="javascript:void(0)"
                         @click="jumpToPrivateDetail">{{ (detail.vpcName) | maybeEmpty }}</a>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('rib.type') | withColon">
                      <span>{{ (detail.typeName) | maybeEmpty }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="router" :label="$t('rib.routeStrategy')">
          <el-table :data="routerTable">
            <el-table-column :label="$t('rib.tableTitle.destination')" prop="destinationCidr">
            </el-table-column>
            <el-table-column :label="$t('rib.tableTitle.nextHopType')" prop="nextHopType">
            </el-table-column>
            <el-table-column :label="$t('rib.tableTitle.nextHop')" prop="nextHop">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getYMD } from '@/common/dataHelper';
import copyValue from '@/components/privateNetwork/CopyValue';

export default {
  name: 'RibDetail',
  components: {
    copyValue
  },
  data() {
    return {
      detail: {
        routeTableId: '',
        name: '',
        createTime: '',
        region: '',
        vpcName: '',
        vpcId: '',
        typeName: ''
      },
      copyHover: false,
      tabName: 'source',
      routerTable: []
    };
  },
  methods: {
    /**
     * 转化时间显示格式
     * @param time
     * @return String
     */
    transformTime(time) {
      if (time === '') {
        return '';
      }
      return getYMD(new Date(time));
    },
    /**
       * 跳转私有网络详情-资源信息
       */
    jumpToPrivateDetail() {
      this.$router.push({
        path: '/vpc/detail',
        query: {
          tabName: 'source',
          region: this.detail.region,
          id: this.detail.vpcId
        }
      });
    },
    /**
       * 复制成功时
       */
    onCopy() {
      this.copyHover = true;
    },
    /**
       * 复制失败时
       */
    onError() {},
    /**
       * 返回列表页
       */
    goBack() {
      this.$router.push({
        path: '/routeTable/list',
        query: {
          region: this.detail.region
        }
      });
    },
    /**
       * 查询路由表资源详情
       * @param params
       */
    getRipDetail(params) {
      Ajax.get('/api/cps/routeTables', params)
        .then((res) => {
          this.detail = Object.assign({}, this.detail, res.data.routeTable);
          this.routerTable = res.data.routeTable.routes;
          this.detail.regionName = this.$route.query.regionName;
        })
        .catch();
    },
    /**
     * 转换返回详情中的routeType
     * 按照交互均为默认路由
     * @param type
     * @return {*}
     */
    transformRouteType(type) {
      switch (type) {
        case '':
          return '';
        default:
          return this.$t('rib.defaultRib');
      }
    }
  },
  created() {
    const params = {
      region: this.$route.query.region,
      routeTableId: this.$route.query.routeTableId,
    };
    this.getRipDetail(params);
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/detailCommon.scss";
  .rib-detail {
    .base-info-form {
      .jc-col { // 避免编辑复制等图标带来的高度不一致的问题
        height: 55px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/rib/RibDetail.vue